import { useMemo } from 'react';
import { lt } from '@mews/framework';
import { DataTestId } from '@mews-commander/enums';
import { ShowButton } from '../styles';
import { AssistantSearchType, SearchType } from '../../assistantSearchTypes';

interface AssistantSearchResultListShowMoreButtonProps {
    searchType: AssistantSearchType;
    searchListLength: number;
    isShowMore: boolean;
    handleShowMore: (type: SearchType) => void;
    handleShowLess: (type: SearchType) => void;
}

export const AssistantSearchResultListShowMoreButton = ({
    searchType,
    isShowMore,
    handleShowMore,
    handleShowLess,
}: AssistantSearchResultListShowMoreButtonProps) =>
    useMemo(
        () => (
            <>
                {isShowMore ? (
                    <ShowButton
                        data-test-id={DataTestId.AssistantResultShowMore + searchType}
                        onClick={(e) => {
                            handleShowMore(searchType as SearchType);
                            e.stopPropagation();
                            e.preventDefault();
                        }}
                        role="button"
                        tabIndex={0}
                    >
                        {lt('ShowMore')}
                    </ShowButton>
                ) : (
                    <ShowButton
                        onClick={(e) => {
                            handleShowLess(searchType as SearchType);
                            e.stopPropagation();
                            e.preventDefault();
                        }}
                        role="button"
                        tabIndex={0}
                    >
                        {lt('ShowLess')}
                    </ShowButton>
                )}
            </>
        ),
        [handleShowLess, handleShowMore, isShowMore, searchType]
    );
